export const lazy = (component) => () => import(`@/${component}.vue`)



// WEBPACK FOOTER //
// ./src/service/lazy.js